import { TonConnectUIProvider } from "@tonconnect/ui-react";
import * as Sentry from "@sentry/react";
import Home from "./Home";
import { MANIFEST_URL } from "./constants";

const Fallback = () => (
  <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-6 text-center bg-telegram-bg text-telegram-text">
    <h1 className="text-2xl font-bold">Something went wrong</h1>
    <p className="text-telegram-hint max-w-sm">
      The app hit an unexpected error. Please reopen it — if it keeps
      happening, let us know at{" "}
      <a href="https://t.me/tonskiton" className="text-telegram-link underline">
        @tonskiton
      </a>
      .
    </p>
    <button
      onClick={() => window.location.reload()}
      className="mt-2 bg-telegram-button text-telegram-button-text px-6 py-3 rounded-xl"
    >
      Reload
    </button>
  </div>
);

const App = () => {
  return (
    <div className="bg-telegram-bg min-h-screen min-w-full">
      <Sentry.ErrorBoundary fallback={<Fallback />}>
        <TonConnectUIProvider manifestUrl={MANIFEST_URL}>
          <Home />
        </TonConnectUIProvider>
      </Sentry.ErrorBoundary>
    </div>
  );
};

export default App;
